import { useState } from "react";

export const useModals = () => {
    const [modalScraping, setModalScraping] = useState<{
        open: boolean;
        row: any;
    }>({
        open: false,
        row: null,
    });

    const [modalActivationManual, setModalActivationManual] = useState<{
        open: boolean;
        row: any;
    }>({
        open: false,
        row: null,
    });

    const [modalActivationAuto, setModalActivationAuto] = useState<{
        open: boolean;
        row: any;
    }>({
        open: false,
        row: null,
    });

    const [modalCreateStrategy, setModalCreateStrategy] = useState<{
        open: boolean;
        row: any;
    }>({
        open: false,
        row: null,
    });

    const [modalDeactivateStrategy, setModalDeactivateStrategy] = useState<{
        open: boolean;
        row: any;
    }>({
        open: false,
        row: null,
    });

    const [confirmDisable, setConfirmDisable] = useState<{
        open: boolean;
        row: any;
        mode: string | null;
    }>({
        open: false,
        row: null,
        mode: null,
    });

    const [openEnforceModal, setOpenEnforceModal] = useState<{
        open: boolean;
        row: any;
    }>({
        open: false,
        row: null,
    });

    return {
        modalScraping,
        setModalScraping,
        modalActivationManual,
        setModalActivationManual,
        modalActivationAuto,
        setModalActivationAuto,
        modalCreateStrategy,
        setModalCreateStrategy,
        modalDeactivateStrategy,
        setModalDeactivateStrategy,
        confirmDisable,
        setConfirmDisable,
        openEnforceModal,
        setOpenEnforceModal,
    };
};